/*
 * MUTE OFFICE v3 — PDP Logic (v3.5 — Idempotent Re-Init + MutationObserver + Cart-Bubble-Selector-Fix)
 *
 * Architektur:
 *  - alle Bind-Funktionen idempotent via dataset.muteInit Guard
 *  - MutationObserver am body: neue [data-mute-pdp-form] / [data-mute-gallery] / [data-mute-sticky-atc] werden auto-initialisiert
 *  - window.MutePdp.reinit() für expliziten Re-Init-Trigger (von Section-JS nach DOM-Swap)
 *  - cart-icon-bubble Selector korrigiert auf #cart-icon-bubble (Dawn-Standard) statt #shopify-section-...
 *  - ensureSlideLoaded: kein src-Reset mehr, nur loading=lazy entfernen
 *
 * Source-Pattern: github.com/Shopify/dawn (cart-drawer.js)
 */
(function(){
  'use strict';

  /* ===== DAWN CART-DRAWER SECTIONS-TO-RENDER ===== */
  var DAWN_SECTIONS_TO_RENDER = [
    { id: 'cart-drawer', selector: '#CartDrawer' },
    { id: 'cart-icon-bubble', selector: '#cart-icon-bubble' }
  ];

  function getSectionInnerHTML(html, selector){
    selector = selector || '.shopify-section';
    try {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var el = doc.querySelector(selector);
      return el ? el.innerHTML : null;
    } catch(e){ return null; }
  }

  function renderCartSections(sectionsData){
    if (!sectionsData) return;
    DAWN_SECTIONS_TO_RENDER.forEach(function(section){
      var html = sectionsData[section.id];
      if (!html) return;
      var targetEl = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById('shopify-section-' + section.id);
      if (!targetEl) {
        if (section.id === 'cart-icon-bubble') {
          targetEl = document.querySelector('.cart-count-bubble') || document.querySelector('[data-cart-count]') || document.querySelector('.header__icon--cart');
        }
        if (!targetEl) return;
      }
      var innerHTML = getSectionInnerHTML(html, section.selector);
      if (innerHTML !== null) {
        targetEl.innerHTML = innerHTML;
      }
    });
    var drawerInner = document.querySelector('cart-drawer .drawer__inner');
    if (drawerInner) drawerInner.classList.remove('is-empty');
    var cartDrawerEl = document.querySelector('cart-drawer');
    if (cartDrawerEl) cartDrawerEl.classList.remove('is-empty');
  }

  function openDawnCartDrawer(){
    var cartDrawer = document.querySelector('cart-drawer');
    if (!cartDrawer) return;
    if (typeof cartDrawer.open === 'function') {
      try { cartDrawer.open(); return; } catch(e){}
    }
    setTimeout(function(){
      cartDrawer.classList.add('animate', 'active');
    });
    document.body.classList.add('overflow-hidden');
    var overlay = cartDrawer.querySelector('#CartDrawer-Overlay');
    if (overlay) {
      overlay.addEventListener('click', function(){
        cartDrawer.classList.remove('active');
        document.body.classList.remove('overflow-hidden');
      }, { once: true });
    }
  }

  /* ===== VARIANT PICKER + AJAX ATC (idempotent) ===== */
  function initPdpForm(form){
    if (form.dataset.muteInit === 'yes') return;
    form.dataset.muteInit = 'yes';

    var pid = form.getAttribute('data-product-id');
    var variantsScript = form.querySelector('[data-mute-vp-variants]');
    if (!variantsScript) return;
    var variants;
    try { variants = JSON.parse(variantsScript.textContent); } catch(e){ return; }
    if (!variants || variants.length === 0) return;

    var hiddenId = form.querySelector('[data-mute-vp-id]');
    var priceEl = form.querySelector('[data-mute-vp-price]');
    var availEl = form.querySelector('[data-mute-vp-avail]');
    var atcBtn = form.querySelector('[data-mute-vp-atc]');

    function getGallery(){
      return document.querySelector('[data-mute-gallery][data-product-id="'+pid+'"]');
    }

    function getSelectedOptions(){
      return Array.from(form.querySelectorAll('[data-mute-vp-group]')).map(function(g){
        var input = g.querySelector('input[type="radio"]:checked');
        return input ? input.value : null;
      });
    }

    function findVariant(opts){
      return variants.find(function(v){
        for (var i=0; i<opts.length; i++) {
          if (opts[i] != null && v['option'+(i+1)] !== opts[i]) return false;
        }
        return true;
      });
    }

    function updateOptionStates(){
      form.querySelectorAll('[data-mute-vp-group]').forEach(function(g, gi){
        g.querySelectorAll('[data-mute-vp-option]').forEach(function(o){
          var testOpts = getSelectedOptions().slice();
          testOpts[gi] = o.getAttribute('data-option-value');
          var v = findVariant(testOpts);
          o.classList.toggle('is-unavailable', !v || !v.available);
        });
      });
    }

    function activateSlide(idx){
      var gallery = getGallery();
      if (!gallery) return;
      var galleryMain = gallery.querySelector('[data-mute-gal-main]');
      var galleryThumbs = gallery.querySelector('[data-mute-gal-thumbs]');
      if (!galleryMain) return;
      var slides = galleryMain.querySelectorAll('[data-mute-gal-slide]');
      var thumbs = galleryThumbs ? galleryThumbs.querySelectorAll('[data-mute-gal-thumb]') : [];
      slides.forEach(function(s, i){ s.classList.toggle('is-active', i === idx); });
      thumbs.forEach(function(t, i){ t.classList.toggle('is-active', i === idx); });
      if (window.innerWidth < 990) {
        var slide = slides[idx];
        if (slide) galleryMain.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
      }
    }

    function syncImageForVariant(v){
      var gallery = getGallery();
      if (!v || !v.featured_image || !gallery) return;
      var galleryMain = gallery.querySelector('[data-mute-gal-main]');
      if (!galleryMain) return;
      var slides = galleryMain.querySelectorAll('[data-mute-gal-slide]');
      var matchIdx = -1;
      slides.forEach(function(s, i){
        var img = s.querySelector('img');
        if (img && v.featured_image.src && img.src && img.src.split('?')[0].indexOf((v.featured_image.src.split('?')[0]).replace(/^https?:/,'')) > -1) {
          matchIdx = i;
        }
      });
      if (matchIdx >= 0) activateSlide(matchIdx);
    }

    function updateUI(v){
      if (!v) return;
      if (hiddenId) hiddenId.value = v.id;
      if (priceEl) priceEl.innerHTML = v.price_html;
      var sBtn = document.querySelector('[data-mute-sticky-atc-btn]');
      var sPrice = document.querySelector('[data-mute-sticky-price]');
      if (sPrice) sPrice.innerHTML = v.price_html;
      if (availEl) {
        availEl.innerHTML = v.available
          ? '<span class="mute-vp__avail-tag mute-vp__avail-tag--in">Lieferbar</span>'
          : '<span class="mute-vp__avail-tag mute-vp__avail-tag--out">Ausverkauft</span>';
      }
      if (atcBtn) {
        atcBtn.disabled = !v.available;
        atcBtn.textContent = v.available ? 'In den Warenkorb' : 'Ausverkauft';
      }
      if (sBtn) {
        sBtn.disabled = !v.available;
        sBtn.setAttribute('data-variant-id', v.id);
        sBtn.textContent = v.available ? 'In den Warenkorb' : 'Ausverkauft';
      }
      try {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        history.replaceState(null, '', url.toString());
      } catch(e){}
      syncImageForVariant(v);
      updateOptionStates();
    }

    form.querySelectorAll('input[type="radio"]').forEach(function(inp){
      inp.addEventListener('change', function(){
        var group = inp.closest('[data-mute-vp-group]');
        if (group) {
          group.querySelectorAll('[data-mute-vp-option]').forEach(function(o){ o.classList.remove('is-selected'); });
          var label = inp.closest('[data-mute-vp-option]');
          if (label) label.classList.add('is-selected');
          var sel = group.querySelector('[data-mute-vp-selected-label]');
          if (sel) sel.textContent = inp.value;
        }
        updateUI(findVariant(getSelectedOptions()));
      });
    });

    var qtyInput = form.querySelector('[data-mute-vp-qty]');
    var qtyUp = form.querySelector('[data-mute-vp-qty-up]');
    var qtyDown = form.querySelector('[data-mute-vp-qty-down]');
    if (qtyUp && qtyInput) qtyUp.addEventListener('click', function(){ qtyInput.value = Math.min(99, parseInt(qtyInput.value || 1, 10) + 1); });
    if (qtyDown && qtyInput) qtyDown.addEventListener('click', function(){ qtyInput.value = Math.max(1, parseInt(qtyInput.value || 1, 10) - 1); });

    form.addEventListener('submit', function(e){
      e.preventDefault();
      if (atcBtn) { atcBtn.disabled = true; atcBtn.textContent = 'Wird hinzugefügt …'; }

      var fd = new FormData(form);
      fd.append('sections', DAWN_SECTIONS_TO_RENDER.map(function(s){ return s.id; }).join(','));
      fd.append('sections_url', window.location.pathname);

      fetch('/cart/add.js', {
        method: 'POST',
        body: fd,
        headers: { 'Accept':'application/javascript', 'X-Requested-With':'XMLHttpRequest' }
      })
        .then(function(r){ return r.json(); })
        .then(function(data){
          if (data.status && data.status >= 400) {
            throw new Error(data.description || data.message || 'Fehler beim Hinzufügen');
          }
          renderCartSections(data.sections);
          document.dispatchEvent(new CustomEvent('mute:cart:refresh'));
          setTimeout(openDawnCartDrawer, 50);
          if (window.PUB_SUB_EVENTS && window.publish) {
            try {
              window.publish(window.PUB_SUB_EVENTS.cartUpdate, {
                source: 'mute-pdp',
                productVariantId: data.variant_id || (findVariant(getSelectedOptions()) || {}).id,
                cartData: data
              });
            } catch(e){}
          }
          if (atcBtn) {
            atcBtn.disabled = false;
            atcBtn.textContent = 'Drin. Weitermachen?';
            setTimeout(function(){ atcBtn.textContent = 'In den Warenkorb'; }, 2000);
          }
          if (window.dataLayer) {
            var v = findVariant(getSelectedOptions());
            window.dataLayer.push({
              event: 'add_to_cart',
              ecommerce: {
                currency: 'EUR',
                value: (v ? v.price/100 : 0),
                items: [{
                  item_id: pid,
                  item_variant: v ? v.title : '',
                  price: v ? v.price/100 : 0,
                  quantity: parseInt(qtyInput ? qtyInput.value : 1, 10)
                }]
              }
            });
          }
          document.dispatchEvent(new CustomEvent('mute:cart:added', { detail: { item: data } }));
          if ('vibrate' in navigator) navigator.vibrate(10);
        })
        .catch(function(err){
          if (atcBtn) { atcBtn.disabled = false; atcBtn.textContent = 'Fehler — neu versuchen'; setTimeout(function(){ atcBtn.textContent = 'In den Warenkorb'; }, 2500); }
          if (window.MuteToast) window.MuteToast.show('Irgendwas hat geklemmt. Lade die Seite neu, dann gehts.', 'error');
          console.warn('[mute-pdp] ATC error', err);
        });
    });

    var sBtnInit = document.querySelector('[data-mute-sticky-atc-btn]');
    if (sBtnInit && sBtnInit.dataset.muteStickyBound !== 'yes') {
      sBtnInit.dataset.muteStickyBound = 'yes';
      sBtnInit.addEventListener('click', function(){
        var activeForm = document.querySelector('[data-mute-pdp-form]');
        if (activeForm) activeForm.dispatchEvent(new Event('submit', { cancelable: true }));
      });
    }

    updateOptionStates();
  }

  /* ===== GALLERY (idempotent) ===== */
  function initGallery(gallery){
    if (gallery.dataset.muteInit === 'yes') return;
    gallery.dataset.muteInit = 'yes';

    var slides = gallery.querySelectorAll('[data-mute-gal-slide]');
    var thumbs = gallery.querySelectorAll('[data-mute-gal-thumb]');
    var lb = gallery.querySelector('[data-mute-gal-lb]');
    var lbImg = gallery.querySelector('[data-mute-gal-lb-img]');
    var lbCounter = gallery.querySelector('[data-mute-gal-lb-counter]');
    var lbClose = gallery.querySelector('[data-mute-gal-lb-close]');
    var lbPrev = gallery.querySelector('[data-mute-gal-lb-prev]');
    var lbNext = gallery.querySelector('[data-mute-gal-lb-next]');
    var currentIdx = 0;
    var slideCount = slides.length;
    if (slides[0]) slides[0].classList.add('is-active');

    function preloadAllSlides(){
      slides.forEach(function(s){
        var img = s.querySelector('img');
        if (!img) return;
        if (img.getAttribute('loading') === 'lazy') {
          img.removeAttribute('loading');
        }
      });
    }
    if (typeof window.requestIdleCallback === 'function') {
      window.requestIdleCallback(preloadAllSlides, { timeout: 1500 });
    } else {
      setTimeout(preloadAllSlides, 800);
    }

    function ensureSlideLoaded(idx){
      var slide = slides[idx];
      if (!slide) return;
      var img = slide.querySelector('img');
      if (!img) return;
      if (img.complete && img.naturalWidth > 0) return;
      if (img.getAttribute('loading') === 'lazy') img.removeAttribute('loading');
    }

    function setActive(idx){
      if (idx < 0) idx = slideCount - 1;
      if (idx >= slideCount) idx = 0;
      currentIdx = idx;
      slides.forEach(function(s, i){ s.classList.toggle('is-active', i === idx); });
      thumbs.forEach(function(t, i){ t.classList.toggle('is-active', i === idx); });
      ensureSlideLoaded(idx);
      if (window.innerWidth < 990) {
        var slide = slides[idx];
        var main = gallery.querySelector('[data-mute-gal-main]');
        if (slide && main) main.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
      }
    }

    function openLightbox(idx){
      if (!lb || !slides[idx]) return;
      var slide = slides[idx];
      var img = slide.querySelector('img');
      if (!img || !lbImg) return;
      if (slide.getAttribute('data-media-type') === 'external_video') {
        var host = slide.getAttribute('data-external-host');
        var extId = slide.getAttribute('data-external-id');
        if (host === 'youtube') window.open('https://www.youtube.com/watch?v='+extId, '_blank');
        else if (host === 'vimeo') window.open('https://vimeo.com/'+extId, '_blank');
        return;
      }
      lbImg.src = img.src.replace(/width=\d+/, 'width=1600');
      lbImg.alt = img.alt;
      if (lbCounter) lbCounter.textContent = (idx+1) + ' / ' + slideCount;
      currentIdx = idx;
      if (typeof lb.showModal === 'function') lb.showModal();
      else lb.setAttribute('open', '');
      document.body.style.overflow = 'hidden';
    }

    function closeLightbox(){
      if (!lb) return;
      if (typeof lb.close === 'function') lb.close();
      else lb.removeAttribute('open');
      document.body.style.overflow = '';
    }

    function lbStep(delta){
      var newIdx = currentIdx + delta;
      if (newIdx < 0) newIdx = slideCount - 1;
      if (newIdx >= slideCount) newIdx = 0;
      openLightbox(newIdx);
    }

    slides.forEach(function(s, i){ s.addEventListener('click', function(){ openLightbox(i); }); });
    thumbs.forEach(function(t, i){ t.addEventListener('click', function(){ setActive(i); }); });
    if (lbClose) lbClose.addEventListener('click', closeLightbox);
    if (lbPrev) lbPrev.addEventListener('click', function(){ lbStep(-1); });
    if (lbNext) lbNext.addEventListener('click', function(){ lbStep(1); });
    if (lb) {
      lb.addEventListener('click', function(e){ if (e.target === lb) closeLightbox(); });
      document.addEventListener('keydown', function(e){
        if (!lb.open) return;
        if (e.key === 'Escape') closeLightbox();
        else if (e.key === 'ArrowLeft') lbStep(-1);
        else if (e.key === 'ArrowRight') lbStep(1);
      });
    }

    var mainContainer = gallery.querySelector('[data-mute-gal-main]');
    if (mainContainer && window.innerWidth < 990) {
      var scrollTimer = null;
      mainContainer.addEventListener('scroll', function(){
        if (scrollTimer) clearTimeout(scrollTimer);
        scrollTimer = setTimeout(function(){
          var slideWidth = mainContainer.clientWidth;
          if (slideWidth <= 0) return;
          var newIdx = Math.round(mainContainer.scrollLeft / slideWidth);
          if (newIdx >= 0 && newIdx < slideCount && newIdx !== currentIdx) {
            currentIdx = newIdx;
            slides.forEach(function(s, i){ s.classList.toggle('is-active', i === newIdx); });
            thumbs.forEach(function(t, i){ t.classList.toggle('is-active', i === newIdx); });
            ensureSlideLoaded(newIdx);
          }
        }, 100);
      }, { passive: true });
    }
  }

  /* ===== STICKY ATC OBSERVER (idempotent) ===== */
  function initStickyAtc(stickyBar){
    if (stickyBar.dataset.muteInit === 'yes') return;
    stickyBar.dataset.muteInit = 'yes';
    stickyBar.hidden = false;
    var mainAtc = document.querySelector('[data-mute-vp-atc]');
    if (!mainAtc) return;
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        stickyBar.classList.toggle('is-visible', !e.isIntersecting);
      });
    }, { rootMargin: '0px 0px -80% 0px' });
    io.observe(mainAtc);
  }

  /* ===== ORCHESTRATION ===== */
  function initAll(){
    document.querySelectorAll('[data-mute-pdp-form]').forEach(initPdpForm);
    document.querySelectorAll('[data-mute-gallery]').forEach(initGallery);
    document.querySelectorAll('[data-mute-sticky-atc]').forEach(initStickyAtc);
  }

  function resetAndReinit(){
    var sBtn = document.querySelector('[data-mute-sticky-atc-btn]');
    if (sBtn && sBtn.dataset.muteStickyBound) delete sBtn.dataset.muteStickyBound;
    initAll();
  }

  window.MutePdp = window.MutePdp || {};
  window.MutePdp.reinit = resetAndReinit;
  window.MutePdp.initAll = initAll;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  var pendingInit = null;
  var observer = new MutationObserver(function(mutations){
    var hasRelevant = false;
    for (var i=0; i<mutations.length; i++) {
      var m = mutations[i];
      for (var j=0; j<m.addedNodes.length; j++) {
        var n = m.addedNodes[j];
        if (n.nodeType !== 1) continue;
        if (n.matches && (n.matches('[data-mute-pdp-form]') || n.matches('[data-mute-gallery]') || n.matches('[data-mute-sticky-atc]'))) {
          hasRelevant = true; break;
        }
        if (n.querySelector && (n.querySelector('[data-mute-pdp-form]') || n.querySelector('[data-mute-gallery]') || n.querySelector('[data-mute-sticky-atc]'))) {
          hasRelevant = true; break;
        }
      }
      if (hasRelevant) break;
    }
    if (!hasRelevant) return;
    if (pendingInit) return;
    pendingInit = setTimeout(function(){
      pendingInit = null;
      initAll();
    }, 30);
  });
  observer.observe(document.body, { childList: true, subtree: true });

  document.addEventListener('mute:pdp:switched', resetAndReinit);

  document.dispatchEvent(new CustomEvent('mute:pdp:ready'));
})();
